/**
 * RAC-10417 — resolve the Enterprise band's call to action on /pricing.
 *
 * /pricing renders for guests AND authenticated users (Pricing.vue picks
 * GuestLayout vs TailwindLayout), but `get-started` sits behind the `guest`
 * middleware. Pointing every visitor at get-started meant an authenticated
 * click was swallowed by RedirectIfAuthenticated and dumped on / with no
 * message — a silent dead end on the page marketing drives traffic to.
 *
 * Existing account holders with growing portfolios are the likeliest
 * Enterprise prospects, so they get a working path rather than a hidden band.
 */

export const ENTERPRISE_CONTACT_MAILTO =
    'mailto:info@rentrisk.com?subject=RentRisk%20Enterprise%20inquiry'

const GUEST_DESCRIPTION =
    'Have a team managing a large rental portfolio? Apply for a RentRisk Enterprise account with screening access for your whole organization.'

const AUTHENTICATED_DESCRIPTION =
    'Have a team managing a large rental portfolio? Get in touch and we will move your account onto RentRisk Enterprise.'

const ENTERPRISE_DESCRIPTION =
    'Finish your RentRisk Enterprise application to unlock screening access for your whole organization.'

/**
 * @param {{role?: string}|null|undefined} user  The shared auth.user prop, if any.
 * @param {{intake: string, getStarted: string}} hrefs  Pre-resolved Ziggy URLs.
 * @returns {{href: string, label: string, isExternal: boolean, description: string}}
 */
export function resolveEnterpriseCta(user, hrefs) {
    if (user?.role === 'enterprise') {
        return {
            href: hrefs.intake,
            label: 'Continue Application',
            isExternal: false,
            description: ENTERPRISE_DESCRIPTION,
        }
    }

    if (user) {
        return {
            href: ENTERPRISE_CONTACT_MAILTO,
            label: 'Contact Us',
            isExternal: true,
            description: AUTHENTICATED_DESCRIPTION,
        }
    }

    return {
        href: hrefs.getStarted,
        // 86bcd9hg3: matches the pricing-page design ("Apply Now").
        label: 'Apply Now',
        isExternal: false,
        description: GUEST_DESCRIPTION,
    }
}
